import React from 'react';
import TabContainer from '../../../../common/components/tab/containers/tab.containers';
import NexusZonesBasicInfoComponent from './nexus-zone-basic-info.component';

export const NexusZonesComponent = ({ handleInnerFormChange,LifeCycleStatus, selectedNexusZones,NexusNodeType,NexusZoneRank,NexusZoneClassification, back, handleFormSubmit }: any) => {
  const tabItems = [
    {
      id: 1,
      title: 'Nexus-A-Record-Types Details',
      component: <NexusZonesBasicInfoComponent
        handleInnerFormChange={handleInnerFormChange}
        selectedNexusZones={selectedNexusZones}
        NexusZoneClassification={NexusZoneClassification}
        NexusZoneRank={NexusZoneRank}
        NexusNodeType={NexusNodeType}
        LifeCycleStatus={LifeCycleStatus}
      />,
      isVisible: true,
    },
  ]

  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">

      <TabContainer tabItems={tabItems} />

      <div className='flex w-full justify-end items-end'>
        <button
          onClick={back}
          type='button'
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
        >
          Back
        </button>
        <button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
          onClick={handleFormSubmit}
          type="submit"
        >
          Save
        </button>
      </div>
    </div>
  )
}

export default NexusZonesComponent;
